import Head from 'next/head';
import AboutContent from '@/content/Info/About';
import { styled, Box } from '@mui/material';

const RootWrapper = styled(Box)(
  ({ theme }) => `
        margin-top: ${theme.spacing(5)};
`
);

function About() {
  return (
    <>
      <Head>
        <title>About us</title>
      </Head>

      <AboutContent />
    </>
  );
}

export default About;
